import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CheckboxInput from 'packages/ui/CheckboxInput';
import FieldContainer from 'packages/ui/FieldContainer';
import { provinces } from 'helpers/statics/provinces';

const CheckboxGroup = styled('div')`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-bottom: 5px;
    margin-left: 20px;
    width: 130px;
  }
`;

function ProvincesInput({ extraOptions, onChange, value }) {
  const selected = value && value.length > 0 ? value : [];
  const options = [...provinces, ...extraOptions];

  return (
    <FieldContainer label="استان‌های موردنطر را انتخاب کنید">
      <CheckboxGroup>
        {options.map(province => (
          <CheckboxInput
            key={province.id}
            checked={selected.includes(province.id)}
            description={province.name}
            size="small"
            onChange={event => {
              onChange(
                event.target.checked
                  ? [...selected, province.id]
                  : selected.filter(prov => prov !== province.id)
              );
            }}
          />
        ))}

        <CheckboxInput
          key="all"
          checked={selected.length === 0}
          description="همه"
          size="small"
          onChange={event => {
            onChange(event.target.checked ? [] : [...selected]);
          }}
        />
      </CheckboxGroup>
    </FieldContainer>
  );
}

ProvincesInput.propTypes = {
  extraOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  )
};

ProvincesInput.defaultProps = {
  extraOptions: []
};

export default memo(ProvincesInput);
